<div class="btn-wrpr">
  <ion-button
    [disabled]="isDisabled"
    class="mm-btn"
    (click)="handleClick()"
    [ngClass]="buttonClass"
    [ngStyle]="buttonStyles"
    [expand]="expand"
  >
    <img
      *ngIf="iconSrc && iconPlacement === 'BEFORE'"
      class="btn-icon"
      [ngClass]="{ 'btn-icon--before': btnTxt }"
      [src]="iconSrc"
    />
    <span>{{ showProcessingBtnTxt ? 'Processing...' : btnTxt }}</span>
    <img
      *ngIf="iconSrc && iconPlacement === 'AFTER'"
      [ngClass]="{ 'btn-icon--after': btnTxt }"
      class="btn-icon"
      [src]="iconSrc"
    />
  </ion-button>
  <!-- TODO: fix below popover -->
  <!-- [id]="enhancedPopoverInfo ? enhancedPopoverInfo.id : 'hover-trigger'" -->
  <!-- <ion-popover
  *ngIf="enhancedPopoverInfo && enhancedPopoverInfo.id"
  [trigger]="enhancedPopoverInfo.id"
  animation="false"
  triggerAction="hover"
  showBackdrop="false"
>
  <ng-template>
    <div class="popover-info">
      <div *ngIf="enhancedPopoverInfo.title" class="popover-info__title">{{ enhancedPopoverInfo.title }}</div>
      <div>{{ enhancedPopoverInfo.txt }}</div>
    </div>
  </ng-template>
</ion-popover> -->
</div>
